import React, { useState } from "react";
import footerLogo from "@/assets/FooterLogo.png";
import SupportIntakeModal from "@/components/SupportIntakeModal";
import {
  MainContainer,
  InnerContainer,
  FooterHeading,
  FooterBody,
  LogoWrapper,
  FooterLogo,
  MenuColumn,
  StyledLink,
  FooterTextWrapper,
  FooterText,
  FooterHeadingmb,
} from "./styles";

const Footer = () => {
  const [supportOpen, setSupportOpen] = useState(false);

  return (
    <MainContainer>
      <InnerContainer>
        <FooterHeading>{`GROW YOUR BUSINESS WITH ECOM DROPSHIP`}</FooterHeading>
        <FooterBody>
          <LogoWrapper>
            <FooterLogo src={footerLogo}></FooterLogo>
          </LogoWrapper>
          <FooterHeadingmb>{`GROW YOUR BUSINESS WITH ECOM DROPSHIP`}</FooterHeadingmb>
          <MenuColumn>
            <StyledLink href="#">{`COMPANY`}</StyledLink>
            <StyledLink href="/about">{`About ECOM DROPSHIP`}</StyledLink>
            <StyledLink href="/terms_services">{`Terms of Service`}</StyledLink>
            <StyledLink href="/privacy_policy">{`Privacy Policy`}</StyledLink>
          </MenuColumn>
          <MenuColumn>
            <StyledLink
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSupportOpen(true);
              }}
            >{`HELP & SUPPORT`}</StyledLink>
            <StyledLink href="/shipping">{`Shipping Policy`}</StyledLink>
            <StyledLink href="/return_policy">{`Return Policy`}</StyledLink>
            <StyledLink href="/supplier">{`Become a supplier`}</StyledLink>
          </MenuColumn>
          <FooterTextWrapper>
            <FooterText>
              {
                "Your trusted partner in eCommerce — helping thousands of entrepreneurs build and grow successful online businesses."
              }
            </FooterText>
          </FooterTextWrapper>
        </FooterBody>
      </InnerContainer>
      <SupportIntakeModal
        open={supportOpen}
        onClose={() => setSupportOpen(false)}
      />
    </MainContainer>
  );
};

export default Footer;
